import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
  bigInputRoot: {
    borderRadius: 4,
    backgroundColor: '#fff',
    border: 0,
    fontSize: 25,
    fontWeight: 'normal',
    minHeight: '50px',
    paddingBottom: '0px !important',

    boxShadow: '0 2px 5px 2px rgba(0, 0, 0, 0.09), 0 2px 4px 0 rgba(0, 0, 0, 0.1)',
    '&:lang(en)': {
      fontSize: 23,
    },
    '&:lang(de)': {
      fontSize: 17,
    },
    '&:lang(it)': {
      fontSize: 18,
    },
    '&:lang(fr)': {
      fontSize: 18,
    },

    '&::placeholder': {
      color: '#9b9b9b',
      opacity: 1,
    },
  },
  bigInput: {
    padding: '15px !important',
    '&::placeholder': {
      color: '#5e5e5e',
      opacity: 1,
    },
  },
  basicInput: {
    '&::placeholder': {
      color: '#5e5e5e',
      opacity: 1,
    },
  },
});

export default useStyles;
